/* eslint-disable no-return-assign */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, InputNumber, Icon, Button, Table } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from '../../index.less';

const defaultProps = {};
const propTypes = {
  filter: PropTypes.object.isRequired,
  handleValueChange: PropTypes.func.isRequired,
};

const cx = classNames.bind(styles);

const Total = 'Total';

class DistributionModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalVisible: false,
      distribution: [],
    };
  }

  setRowStyles = record => {
    if (record.value === Total) return cx('distribution-table-highlight');
    return '';
  }

  getDistributionPercentage = (distributionValue) => {
    const totalRow = distributionValue.find(d => d.value === Total);
    const totalWeight = totalRow.weight ? totalRow.weight : 1;
    return distributionValue.map(d => {
      if (d.value === Total) return d;
      return ({
        ...d,
        percentage: (Math.round(d.weight / totalWeight * 1000) / 10.0)
      });
    });
  }

  getTotalWeight = (distribution) => {
    let totalWeight = 0;
    distribution.forEach(d => {
      if (d.value !== Total) {
        totalWeight += d.weight;
      }
    });
    return totalWeight;
  }

  handleWeightChange = (weight, selectedIndex) => {
    const { distribution } = this.state;
    if (!_.isNumber(weight)) return;
    const changedDistribution = distribution.map(d => {
      if (d.index === selectedIndex) {
        return {
          ...d,
          weight
        };
      }
      return d;
    });
    const totalWeight = this.getTotalWeight(changedDistribution);
    const setTotalWeight = changedDistribution.map(d => {
      if (d.value === Total) {
        return {
          ...d,
          weight: totalWeight
        };
      }
      return d;
    });
    this.setState({ distribution: this.getDistributionPercentage(setTotalWeight) });
  }

  hanleModalOpen = () => {
    this.setState({ modalVisible: true });
    const { filter } = this.props;
    const { value, distributionValue } = filter;
    const valueToArray = value ? value.trim().split(',') : [];
    const distribution = valueToArray.map((v, index) => {
      const selectedValue = distributionValue.find(d => d.value === v);
      if (!_.isEmpty(selectedValue)) {
        return {
          index,
          weight: selectedValue.weight,
          value: v,
        };
      }
      return {
        index,
        weight: 1,
        value: v
      };
    });
    distribution.push({
      index: distribution.length,
      weight: this.getTotalWeight(distribution),
      percentage: 100,
      value: Total,
    });
    const parsedValue = this.getDistributionPercentage(distribution);
    this.setState({
      distribution: parsedValue,
    });
  }

  handleEqually = () => {
    const { distribution } = this.state;
    const equallyValue = distribution.map(d => ({
      ...d,
      weight: 1,
    }));
    const totalWeight = equallyValue.map(d => {
      if (d.value === Total) {
        return {
          ...d,
          weight: this.getTotalWeight(equallyValue)
        };
      }
      return d;
    });
    const parsedValue = this.getDistributionPercentage(totalWeight);
    this.setState({
      distribution: parsedValue
    });
  }

  handleCancel = () => {
    this.setState({ modalVisible: false });
  }

  hanledModuleOk = () => {
    const { handleValueChange } = this.props;
    const { distribution } = this.state;
    this.setState({ modalVisible: false });
    const valueWithoutTotal = distribution.filter(d => d.value !== Total);
    const parseValue = valueWithoutTotal.map(v => _.omit(v, ['index', 'percentage']));
    handleValueChange(parseValue);
  }

  render() {
    const { distribution } = this.state;

    const footer = [
      (
        <div className="pull-left" key="equal">
          <Button onClick={this.handleEqually} className={cx('modal-btn-cutsom')}>
            <FormattedMessage id="page.WorkFlow.equallyDistributed" />
          </Button>
        </div>
      ),
      (
        <Button onClick={this.handleCancel} className={cx('modal-btn-cutsom')} key="cancel">
          <FormattedMessage id="global.ui.button.cancel" />
        </Button>
      ),
      (
        <Button key="submit" type="primary" onClick={this.hanledModuleOk}>
          <FormattedMessage id="global.ui.button.ok" />
        </Button>
      ),
    ];

    const columns = [
      {
        title: <FormattedMessage id="page.WorkFlow.modalTableHeader.item" />,
        dataIndex: 'value',
        key: 'value'
      },
      {
        title: <FormattedMessage id="page.WorkFlow.modalTableHeader.weight" />,
        dataIndex: 'weight',
        key: 'weight',
        render: (text, record) => {
          if (record.value === 'Total') return text;
          return (
            <InputNumber
              className="full-width"
              value={text}
              step={1}
              onChange={value => this.handleWeightChange(value, record.index)}
            />
          );
        },
      },
      {
        title: <FormattedMessage id="page.WorkFlow.modalTableHeader.percentage" />,
        dataIndex: 'percentage',
        key: 'percentage',
        render: text => (
          <span>{`${text}%`}</span>
        )
      }
    ];

    return (
      <React.Fragment>
        <Icon
          type="pie-chart"
          className={classNames(cx('distribution-icon'), 'mr-sm cursor-pointer')}
          onClick={this.hanleModalOpen}
        />
        <Modal
          title={<FormattedMessage id="page.WorkFlow.distribution" />}
          visible={this.state.modalVisible}
          onCancel={this.handleCancel}
          footer={footer}
        >
          <Table
            className="distribution-modal-table"
            bordered
            pagination={false}
            columns={columns}
            dataSource={distribution}
            rowClassName={this.setRowStyles}
            rowKey="index"
          />
        </Modal>
      </React.Fragment>
    );
  }
}

DistributionModal.defaultProps = defaultProps;
DistributionModal.propTypes = propTypes;

export default DistributionModal;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/CommonComponents/DistributionModal.jsx